var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedsRefill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.3C0 .858.392.5.875.5h12.25c.483 0 .875.358.875.8v2.4c0 .442-.392.8-.875.8h-.875v11.2c0 .442-.392.8-.875.8h-8.75c-.483 0-.875-.358-.875-.8V4.5H.875C.392 4.5 0 4.142 0 3.7V1.3Zm3.5 3.2h7v.8H8.75v1.6h1.75v1.6H7.875v1.6H10.5v1.6H6.125v1.6H10.5v1.6h-7V4.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedsRefill);
export default __webpack_public_path__ + "static/media/meds_refill.05e34e8fd2652c0b553d64c810494931.svg";
export { ForwardRef as ReactComponent };